import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { StudentHistoryDashboard } from '../models/student-history-dashboard';
import { AppSettings } from '../../../../utils/app-settings';

@Injectable({
  providedIn: 'root'
})
export class StudentHistoryService {

  constructor(private http: HttpClient) { }

  getHistoryDashboard(): Observable<StudentHistoryDashboard> {
    return this.http.get<StudentHistoryDashboard>(AppSettings.apiUrl + "StudentHistory/dashboard");
  }
}
